import { jsx as _jsx } from "react/jsx-runtime";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { twMerge } from 'tailwind-merge';
const Item = ({ item, disabled }) => {
    const isDisabled = disabled || item.disabled;
    const { setNodeRef, attributes, listeners, transform, transition, isDragging } = useSortable({
        id: item.id,
        data: {
            type: 'Item',
            item,
        },
        disabled: isDisabled,
    });
    const style = {
        transition,
        transform: CSS.Transform.toString(transform),
    };
    if (isDisabled) {
        return _jsx("div", { className: `cursor-not-allowed`, children: item.content });
    }
    if (isDragging) {
        return (_jsx("div", { ref: setNodeRef, style: style, className: twMerge('opacity-40', item.draggedStyling), children: item.content }));
    }
    return (_jsx("div", { ref: setNodeRef, style: style, ...attributes, ...listeners, className: `cursor-grab`, children: item.content }));
};
export default Item;
//# sourceMappingURL=Item.js.map